module.exports = __webpack_public_path__ + "36e9c3ec1026af03ccd90083580da373.mp3";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/wat_knap_2.mp3
// module id = 93
// module chunks = 0